import { useGetMetafields } from 'domains/Orders/Orders/hooks';
import RenderMetafieldsWhen from '../../RenderMetafieldWhen';

type ConditionsInterface = {
  hasInternals: boolean;
  hasExternals: boolean;
  isAvailable: boolean;
};

interface RenderVariantMetafieldsWhenProps {
  conditions: ConditionsInterface[];
  children: React.ReactNode;
}

export default function RenderOrderMetafieldsWhen({
  conditions,
  children,
}: RenderVariantMetafieldsWhenProps) {
  const { isAvailable, hasInternals, hasExternals } = useGetMetafields();
  const values = { isAvailable, hasInternals, hasExternals };

  return (
    <RenderMetafieldsWhen values={values} conditions={conditions}>
      {children}
    </RenderMetafieldsWhen>
  );
}
